export const BUSY_MESSAGE_BOOT: string = 'Loading Configuration...';
export const BUSY_MESSAGE_LOADING: string = 'Loading. Please wait...';
export const BUSY_MESSAGE_LOOKING: string = 'Looking. Please wait...';
export const BUSY_MESSAGE_DEFAULT: string = BUSY_MESSAGE_LOADING.slice(0);
